import AddCollegeAndCourse from "../../Components/Modals/AddCollegeAndCourse";
import Table from "../../Components/Table";
import { deleteCollegeAndCourseById, getAllCourseAndCollege } from "../../Services/CollegeService";

const CollegeAndCourse = () => {
    const columns = [
        {
            label: "College Name",
            value: "college_name"
        },
        {
            label: "Course Name",
            value: "course_name"
        },
        {
            label: "Fees",
            value: "avg_tution_fee"
        },
        {
            label: "Preferred Gender",
            value: "preferred_gender"
        },
        {
            label: "Rank",
            value: "rank"
        },
    ];

    const renderAddModal = (openAddModal, setOpenAddModal) => {
        return (
            <AddCollegeAndCourse data={openAddModal} onClose={() => setOpenAddModal()} onCloseWithApi={() => setOpenAddModal(true)} />
        )
    };

    return (
        <Table
            api={getAllCourseAndCollege}
            columns={columns}
            title={"College And Course Mapping"}
            addModal={renderAddModal}
            showAddButton={true}
            showExportButton={true}
            deleteApi={deleteCollegeAndCourseById}
        />
    );
}

export default CollegeAndCourse;